import { createStore } from "vuex";

import actions from "./actions";
import state from "./state";
import mutations from "./mutations";
import getters from "./getters";

import baseX from "./modules/baseX";
import panelX from "./modules/panelX";
import jobX from "./modules/jobX";
import dashboardX from "./modules/dashboardX";

const store = createStore({
    state,
    mutations,
    actions,
    getters,
    modules: {
        baseX,
        panelX,
        jobX,
        dashboardX,
    },
});

export default store;
